export function getAuth() {
  return localStorage.getItem('authToken')
}

export function storeAuth(authToken: string) {
  localStorage.setItem('authToken', authToken)
}

export function clearAuth() {
  localStorage.removeItem('authToken')
}
